/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/9/14
 * Time: 7:31 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var ConnectionPanelLayout = require("connection-views/layouts/ConnectionPanelLayout");


    var ConnectionPanelLayoutController = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        ConnectionPanelLayoutController = Marionette.Controller.extend({
            initialize: function (options) {
                this.model = options.model;
                this.connectionPanelLayout = new ConnectionPanelLayout({
                    model: this.model
                });
                this._setEventListeners();
            },
            getMainView: function () {
                return this.connectionPanelLayout;
            },

            _setEventListeners: function () {
                this.listenTo(this.connectionPanelLayout, "render", this._onLayoutRender);
                LEConnection.vent.on("ConnectionPanelLayoutController:showRegion:Ticket", this._showTicketRegion, this);
                LEConnection.vent.on("ConnectionPanelLayoutController:showRegion:Notification", this._showNotificationRegion, this);
                LEConnection.vent.on("ConnectionPanelLayoutController:showRegion:Article", this._showArticleRegion, this);
                LEConnection.vent.on("ConnectionPanelLayoutController:showRegion:mainContainer", this._showMainContainerRegion, this);
                LEConnection.vent.on("ConnectionPanelLayoutController:showRegion:handle", this._showHandleRegion, this);
                LEConnection.vent.on("ConnectionPanelLayoutController:openConnectionPanel", this._openConnectionPanel, this);
                LEConnection.vent.on("ConnectionPanelLayoutController:closeConnectionPanel", this._closeConnectionPanel, this);
            },

            _onLayoutRender: function () {
                LEConnection.vent.trigger("layout:ready", this.connectionPanelLayout);
            },

            _showRegion: function (region, view) {
                if (this.connectionPanelLayout.getIsRendered()) {
                    region.show(view);
                }
                else {
                    this.listenTo(this.connectionPanelLayout, "render", function () {
                        region.show(view);
                    });
                }
            },

            _showArticleRegion: function (options) {
                if (this._isValidShowRegionOptions(options)) {
                    this._showRegion(this.connectionPanelLayout.articleRegion, options.view);
                }
            },
            _showTicketRegion: function (options) {
                if (this._isValidShowRegionOptions(options)) {
                    this._showRegion(this.connectionPanelLayout.ticketRegion, options.view);
                }
            },
            _showNotificationRegion: function (options) {
                if (this._isValidShowRegionOptions(options)) {
                    this._showRegion(this.connectionPanelLayout.notificationRegion, options.view);
                }
            },
            _showMainContainerRegion: function (options) {
                if (this._isValidShowRegionOptions(options)) {
                    this._showRegion(this.connectionPanelLayout.mainContainerRegion, options.view);
                }
            },
            _showHandleRegion: function (options) {
                if (this._isValidShowRegionOptions(options)) {
                    this._showRegion(this.connectionPanelLayout.handleRegion, options.view);
                }
            },
            _isValidShowRegionOptions: function (options) {
                var isValid = false;

                if (options && options.view) {
                    isValid = true;
                }

                return isValid;
            },
            _openConnectionPanel:function(){
                if(this.model.get('hasCriticalNotifications')){
                    this.model.selectNotificationTab();
                }
                this.model.set("isOpen", true);
            },
            _closeConnectionPanel: function () {

                this.model.set({
                    "referrerAction": null,
                    "selectedKP": null
                });
                this.model.set("isOpen", false);
            }

        });
    });
    return ConnectionPanelLayoutController;
});
